import React from 'react';

import { GridContainer, GridItem } from '@xing-com/grid';
import { SkeletonImage } from '@xing-com/skeleton';
import { scale160 } from '@xing-com/tokens';
import { Row, Column } from '@xing-com/xing-grid';

import RecommendationsSkeleton from '../common/recommendations';
import RecruitersRecommendationsSkeleton from '../common/recruiters-recommendations';
import SkeletonContainer from '../common/skeleton-container';

import { Styled } from './styles';

type MyNetworkCardSkeletonProps = {
  amountRows?: number;
};

const MyNetworkCardSkeleton: React.FC<MyNetworkCardSkeletonProps> = ({
  amountRows = 2,
}) => {
  return (
    <Styled.SkeletonCardContainer>
      <SkeletonImage width={scale160} height={scale160} />
      <Styled.SkeletonCardBodyCopy amountRows={amountRows} />
    </Styled.SkeletonCardContainer>
  );
};

export const MyNetworkRecruitersRecommendationSkeleton: React.FC = () => {
  return (
    <React.Fragment>
      <Row>
        <Column size={12}>
          <Styled.SkeletonRecruitersRecommendationsHeadline
            size="medium"
            amountRows={1}
          />
          <Styled.SkeletonRecruitersRecommendationsSubline
            size="small"
            amountRows={1}
          />
        </Column>
      </Row>

      <RecruitersRecommendationsSkeleton />
    </React.Fragment>
  );
};

export const MyNetworkRecommendationSkeleton: React.FC = () => {
  return (
    <React.Fragment>
      <Row>
        <Column size={12}>
          <Styled.SkeletonRecommendationsHeadline size="small" amountRows={1} />
        </Column>
      </Row>

      <RecommendationsSkeleton />
    </React.Fragment>
  );
};

const MyNetworkSkeleton: React.FC = () => {
  return (
    <SkeletonContainer>
      <GridContainer>
        <GridItem span={12}>
          <MyNetworkCardSkeleton amountRows={2} />
        </GridItem>
        <GridItem span={6}>
          <MyNetworkCardSkeleton amountRows={2} />
        </GridItem>
        <GridItem span={6}>
          <MyNetworkCardSkeleton amountRows={2} />
        </GridItem>
        <GridItem span={12}>
          <MyNetworkCardSkeleton amountRows={2} />
        </GridItem>
        <GridItem span={12} spanMedium={6}>
          <MyNetworkCardSkeleton amountRows={5} />
        </GridItem>
        <GridItem span={12} spanMedium={6}>
          <MyNetworkCardSkeleton amountRows={5} />
        </GridItem>
        <GridItem span={12}>
          <MyNetworkCardSkeleton amountRows={1} />
        </GridItem>
        <GridItem span={12}>
          <MyNetworkCardSkeleton amountRows={10} />
        </GridItem>
      </GridContainer>

      <MyNetworkRecruitersRecommendationSkeleton />
      <MyNetworkRecommendationSkeleton />
    </SkeletonContainer>
  );
};

export default MyNetworkSkeleton;
